/**
 * Created by Vladislav on 18.09.2024.
 */

cleverapps.InitConfigByType["match3"] = function () {
    if (typeof Families !== "undefined") {
        Families.initialize();
    }
};

cleverapps.InitByType["match3"] = function () {
    if (typeof UnitsSyncers !== "undefined") {
        cleverapps.unitsSyncers = new UnitsSyncers();
    }

    match3.heroes = new Heroes();
    match3.levelAttempts = new LevelAttempts();
    cleverapps.tutorial.register(StartLevelTutorial());
    cleverapps.tutorial.register(BoosterCellTutorial());
    cleverapps.tutorial.register(HeroesTutorial());

    if (typeof AdventureExpedition !== "undefined") {
        AdventureExpedition.initialize();
    }
};